export const LINKETRY_VERSION = '0.34.1';
